import {ColProps} from "./tableTypes";

export const getStyle = (col: ColProps) => {
    const style: any = {};
    if(col.width !== undefined) style.minWidth = col.width;
    if(col.maxWidth !== undefined) style.maxWidth = col.maxWidth;
    if(col.paddingLeft !== undefined) style.paddingLeft = col.paddingLeft;
    return style;
}